const TRACKED_ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'wbraid',
  'gbraid',
  'msclkid',
  'fbclid',
  'li_fat_id',
  'ga_clientid',
  'slt_device',
  'slt_network',
  'slt_matchtype',
]

export function readAttributionParams(): Record<string, string> {
  const urlParams = new URLSearchParams(window.location.search)
  const fromUrl = pickTracked((key) => urlParams.get(key))
  if (Object.keys(fromUrl).length > 0) {
    return fromUrl
  }
  const stored = readStoredUtmContext()
  return pickTracked((key) => stored[key])
}

function pickTracked(
  get: (key: string) => string | null | undefined
): Record<string, string> {
  const params: Record<string, string> = {}
  for (const key of TRACKED_ATTRIBUTION_PARAMS) {
    const value = get(key)
    if (typeof value === 'string' && value !== '') {
      params[key] = value.slice(0, 255)
    }
  }
  return params
}

function readStoredUtmContext(): Record<string, string> {
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem('slite_utm_context') || '{}'
    )
    if (parsed && typeof parsed === 'object') {
      return parsed as Record<string, string>
    }
  } catch {}
  return {}
}
